var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"height":"50","width":"13","min-width":"68px"}},[_c('img',{staticClass:"employee-avatar__img",attrs:{"src":_vm.avatar,"alt":"avatar-user"}})])}
var staticRenderFns = []

export { render, staticRenderFns }